import type React from 'react'
import {clsx} from 'clsx'
import styles from './EllipsisOverflow.module.css'

export default function EllipsisOverflow({
  side,
  children,
  className,
  title,
}: {
  side: 'left' | 'right'
  children: React.ReactNode
  className?: string
  title: string
}) {
  return (
    // eslint-disable-next-line github/a11y-no-title-attribute -- pre-existing: title used for text truncation tooltip
    <div
      title={title}
      className={clsx(styles.ellipsisOverflow, side === 'left' ? styles.directionRtl : styles.directionLtr, className)}
    >
      {children}
    </div>
  )
}
